var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 22.3125C17.625 22.3125 18.0625 22.375 18.875 21.375L24.8125 14.5C25.2812 13.8438 25.4375 12.875 25.4375 12C25.4375 9.78125 23.5937 7.9375 21.375 7.9375C19.625 7.9375 18.1563 9.5 17.625 11.0625C17.0937 9.5 15.625 7.9375 13.875 7.9375C11.6563 7.9375 9.8125 9.78125 9.8125 12C9.8125 12.875 9.96875 13.8438 10.4375 14.5L16.375 21.375C17.1875 22.375 17.625 22.3125 17.625 22.3125Z",
    stroke: "#373737",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8125 24.375C27.125 21.875 29.5938 18 31.0625 15.75C31.8125 14.5938 32.6875 13.2188 32.625 11.375C32.5313 8.78125 30.5313 6.3125 27.4063 4.59375",
    stroke: "#373737",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9375 4.1875C22.9375 4.1875 22.9375 2.625 24.5 2.625C26.0625 2.625 25.75 2.625 25.75 2.625C25.75 2.625 27.3125 2.625 27.3125 4.1875C27.3125 4.1875 27.3125 5.75 25.75 5.75C24.1875 5.75 24.5 5.75 24.5 5.75C24.5 5.75 22.9375 5.75 22.9375 4.1875Z",
    fill: "#373737",
    stroke: "#373737",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4062 24.3437C8.12499 21.875 5.65624 18 4.18749 15.75C3.43749 14.5937 2.56249 13.2187 2.62499 11.375C2.71874 8.75 4.74999 6.25 7.93749 4.5625",
    stroke: "#373737",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3125 4.1875C12.3125 4.1875 12.3125 2.625 10.75 2.625C9.1875 2.625 9.5 2.625 9.5 2.625C9.5 2.625 7.9375 2.625 7.9375 4.1875C7.9375 4.1875 7.9375 5.75 9.5 5.75C11.0625 5.75 10.75 5.75 10.75 5.75C10.75 5.75 12.3125 5.75 12.3125 4.1875Z",
    fill: "#373737",
    stroke: "#373737",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6874 24.5316C23.3437 23.9379 22.5624 23.7504 21.9687 24.1254C20.5312 25.0004 19.0624 25.4379 17.6249 25.4379C16.1874 25.4379 14.7187 25.0004 13.2812 24.1254C12.6874 23.7816 11.9374 23.9691 11.5624 24.5316C11.2187 25.1254 11.4062 25.8754 11.9687 26.2504C13.4062 27.1254 14.8749 27.6566 16.3749 27.8441V29.8129C16.3749 30.5004 16.9374 31.0629 17.6249 31.0629C18.3124 31.0629 18.8749 30.5004 18.8749 29.8129V27.8441C20.3437 27.6566 21.8437 27.1254 23.2812 26.2504C23.8749 25.8754 24.0624 25.1254 23.6874 24.5316Z",
    fill: "#373737",
    stroke: "#373737",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 31.375V37C17.625 37 17.625 41.375 22 41.375C26.375 41.375 26.375 37 26.375 37C26.375 37 26.375 27.0937 36.375 26.6875",
    stroke: "#373737",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.625 27.9375C38.3154 27.9375 38.875 27.3779 38.875 26.6875C38.875 25.9971 38.3154 25.4375 37.625 25.4375C36.9346 25.4375 36.375 25.9971 36.375 26.6875C36.375 27.3779 36.9346 27.9375 37.625 27.9375Z",
    fill: "#373737",
    stroke: "#373737",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.625 30.4375C39.6961 30.4375 41.375 28.7586 41.375 26.6875C41.375 24.6164 39.6961 22.9375 37.625 22.9375C35.5539 22.9375 33.875 24.6164 33.875 26.6875C33.875 28.7586 35.5539 30.4375 37.625 30.4375Z",
    stroke: "#373737",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.98e881aba49a1f49d444b9e21104fe80.svg";
export { ForwardRef as ReactComponent };